import { css } from 'styled-components'

export const primaryFontMixin = css`
    font-family: ${({ theme }) => theme.typography.fontFamily};
`

export const secondaryFontMixin = css`
    font-family: ${({ theme }) => theme.typography.fontFamily};
`
